import React, { Suspense } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const SignUpCodeListComponent = React.lazy(() => import('./components/SignUpCodeList'));

const SignUpCodeList = () => {
  const { pathname } = useLocation();

  return (
    <>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <SignUpCodeListComponent />
      </Suspense>
    </>
  );
};

export default SignUpCodeList;
